import Request from '@request'
import md5 from 'js-md5'

export function getDetail(params) {
    return Request.post('/api/caa/v1/propaganda/detail', params)
}

export function getAds(params) {
    return Request.post('/api/caa/v1/propaganda/ads', params)
}

export function getEnterprise(params) {
    return Request.post('/api/web/v3/subject/enterpriselogo', params)
}

export function getSharePoster(params) {
    let platform = 8
    const timestamp = new Date() * 1
    const sign = md5('platform=' + platform + '&timestamp=' + timestamp)
    return Request.post('/api/web/v3/meeting/sharemeeting', {
        platform,
        timestamp,
        sign,
        ...params
    })
}

export function getWxShare(params) {
    return Request.sharePost(`https://${location.host}/wechat/share.php`, params)
}

